var icon = require('vue-svgicon')
icon.register({
  'fontawesome/trello': {
    width: 1792,
    height: 1792,
    viewBox: '0 0 1792 1792',
    data: '<path pid="0" d="M832 1344V320q0-14-9-23t-23-9H320q-14 0-23 9t-9 23v1024q0 14 9 23t23 9h480q14 0 23-9t9-23zm672-384V320q0-14-9-23t-23-9H992q-14 0-23 9t-9 23v640q0 14 9 23t23 9h480q14 0 23-9t9-23zm160-768v1408q0 26-19 45t-45 19H192q-26 0-45-19t-19-45V192q0-26 19-45t45-19h1408q26 0 45 19t19 45z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/generated_svg_icons/fontawesome/trello.js